const { stm_clicki } = window;
const _stm = (codeVal) => {
  try {
    const arr = codeVal.split(",");
    const newArr = [];
    arr.forEach((item) => {
      newArr.push(item.trim());
    });
    stm_clicki("send", newArr[0], newArr[1], "点击", newArr[2]);
  } catch (e) {
    console.error(e);
  }
};

export const maidian = (item) => {

  try {
    stm_clicki("send", "event", window.location.href + "页面", "点击", item);
  } catch (e) {
    console.error(e);
  }
};

(function () {
  document.addEventListener("click", function (e) {
    if (e.target?.getAttribute("code-stm")) {
      const codeVal = e.target
        ?.getAttribute("code-stm")
        .replace(/PAGEURL/gi, window.location.href)
        .replace(/<br>/gi, "");
      console.log("%c buriedPoint", "font-size:25px;color:green;", codeVal);
      _stm(codeVal);
    }
  });
})();
